





















































































































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType,
    componentDataType
} from "../types";

import {
    HOST
} from "../global";

@Component({
    name: "HowWework",

})
export default class HowWework extends Vue {
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
    public data() {
        let videoId = (this as any).compData.design_product.video_block.video_id;
        return {
            activetab: "1",
            scrollpos: 0,
            videoId: videoId,
            host: 'https://www.youtube.com'
        }
    }

    playVideo() {
        (this as any).$refs.youtube.player.playVideo()
        const playbtn =
            (this.$refs.plybtn as HTMLElement) ||
            document.querySelector("#play-video");
        playbtn.style.display = 'none';
    }

    player() {
        return (this as any).$refs.youtube.player
    }
    public handleScroll() {
        let scrollpos;
        let d: any = document;
        const nav = d.querySelector('.tab-menu');

        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;
            if (scrollpos > 720) {
                nav.classList.add('tabfixed');
            } else {
                nav.classList.remove('tabfixed');
            }
        });

    }
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    public positiontop() {

        window.scrollTo({
            top: 550,
            left: 0,
            behavior: 'smooth'
        });
    }

    //     add_class_on_scroll() {
    //         const hwtab =
    //             (this.$refs.hwtabs as HTMLElement) ||
    //             document.querySelector(".works-list");
    //         hwtab.style.position = 'fixed';
    //         hwtab.style.top = '0';
    //         hwtab.style.left = '0';

    //     }

    //     remove_class_on_scroll() {
    //         const hwtab =
    //             (this.$refs.hwtabs as HTMLElement) ||
    //             document.querySelector(".works-list");
    //         hwtab.style.position = 'sticky';
    //         hwtab.style.top = 'unset';
    //         hwtab.style.left = 'unset';

    //     }
    //      onScroll () {
    //            scrollpos = window.scrollY
    //         if (scrollpos > 550) {
    //             add_class_on_scroll();
    //         } else {
    //             remove_class_on_scroll();
    //         }
    //     }

    //      mounted () {
    //     window.addEventListener('scroll', this.onScroll)

    //   }
    // window.addEventListener("scroll", (e: any) => {
    //     // scrollpos = window.scrollY,
    //     if (scrollpos > 550) {
    //         add_class_on_scroll();
    //     } else {
    //         remove_class_on_scroll();
    //     }
    // })

    // public beforeDestroy() {
    //     window.removeEventListener('scroll', this.onScroll)
    // }

    //   onScroll () {
    //       if (window.pageYOffset < 0) {
    //         return
    //       }
    //       if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
    //         return
    //       }
    //       this.showNavbar = window.pageYOffset < this.lastScrollPosition
    //       this.lastScrollPosition = window.pageYOffset
    //     }

    //    public beforeDestroy () {
    //     window.removeEventListener('scroll', this.onScroll)
    //   }
    // public mounted () {
    //     this.lastScrollPosition = window.pageYOffset
    //     window.addEventListener('scroll', this.onScroll)
    //     const viewportMeta = document.createElement('meta')
    //     viewportMeta.name = 'viewport'
    //     viewportMeta.content = 'width=device-width, initial-scale=1'
    //     document.head.appendChild(viewportMeta)
    //   }

}
